module.exports = __webpack_public_path__ + "6319ecf8f0d991cc6d01162400156efa.svg";